module.exports = __webpack_public_path__ + "static/img/honour4.fa38633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/honour4.png
// module id = fYs2
// module chunks = 1